(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbh-equipaje"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('mbh-equipaje-root');
  if (!root || root.dataset.started) return;
  root.dataset.started = 'true';
  const field = 'filter.p.m.custom.tipo_de_equipaje';
  const nativeSelector = `input[name="${field}"]`;
  const categorySelector = 'input[name="filter.p.product_type"]';
  const selected = () => new URL(location.href).searchParams.getAll(field).flatMap(v => v.split(','));
  const makeUrl = choices => {
    const url = new URL(location.href);
    url.pathname = root.dataset.allUrl;
    ['page','mbh_page','section_id','mbh_equipaje',field,'filter.p.product_type'].forEach(key => url.searchParams.delete(key));
    url.searchParams.set('filter.p.product_type', 'Equipaje');
    [...new Set(choices)].forEach(value => url.searchParams.append(field, value));
    url.hash = 'main-collection-filters';
    return url;
  };
  // Retain bookmarks from the unpublished prototype; new options come from Shopify.
  const legacy = new URL(location.href).searchParams.get('mbh_equipaje');
  if (legacy) {
    const names = {tanque:'Bolsas de tanque',laterales:'Maletas laterales',topcase:'Top case',alforjas:'Alforjas',colin:'Bolsas de colín',soportes:'Soportes y anillos'};
    location.replace(makeUrl(legacy.split(',').map(key => names[key]).filter(Boolean)).href);
    return;
  }
  const choicesIn = menu => [...menu.querySelectorAll('[data-mbh-sub]:checked')].map(box => box.dataset.mbhSub);
  const bikeTags = () => [...new Set(new URL(location.href).searchParams.getAll('filter.p.tag').filter(tag => /esi\d+/.test(tag)))];
  const preserveBike = () => {
    document.querySelectorAll('facet-filters-form form[id^="FacetFiltersForm"]').forEach(form => {
      form.querySelectorAll('[data-mbh-bike-input]').forEach(input => {
        if (!bikeTags().includes(input.value)) input.remove();
      });
      bikeTags().forEach(tag => {
        const represented = [...form.querySelectorAll('input[name="filter.p.tag"]')].some(input => input.value === tag && (input.checked || input.type === 'hidden'));
        if (represented) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'filter.p.tag';
        input.value = tag;
        input.dataset.mbhBikeInput = 'true';
        form.append(input);
      });
    });
  };
  const mount = () => {
    preserveBike();
    document.querySelectorAll(`${categorySelector}[value="Equipaje"]`).forEach(category => {
      const item = category.closest('li');
      const form = category.form;
      const sources = [...(form?.querySelectorAll(nativeSelector) || [])];
      if (!item || !sources.length) return;
      const values = sources.map(input => {
        const label = input.closest('label');
        const text = label?.querySelector('[aria-hidden="true"]')?.textContent?.trim() || input.value;
        return {value:input.value, checked:input.checked, disabled:input.disabled, text};
      });
      const signature = JSON.stringify(values);
      let menu = item.querySelector('.mbh-equipaje-menu');
      if (menu?.dataset.signature === signature) return;
      const wasOpen = menu?.open;
      menu?.remove();
      const fragment = document.getElementById('mbh-equipaje-controls').content.cloneNode(true);
      menu = fragment.querySelector('details');
      menu.dataset.signature = signature;
      menu.open = wasOpen ?? (category.checked || values.some(value => value.checked));
      const list = menu.querySelector('.mbh-equipaje-choices');
      values.forEach(value => {
        const label = document.createElement('label');
        label.className = 'mbh-equipaje-option';
        const box = document.createElement('input');
        box.type = 'checkbox';
        box.dataset.mbhSub = value.value;
        box.checked = value.checked;
        box.disabled = value.disabled && !value.checked;
        const text = document.createElement('span');
        text.textContent = value.text;
        label.append(box,text);
        list.append(label);
      });
      menu.querySelector('.mbh-equipaje-apply').addEventListener('click', () => location.assign(makeUrl(choicesIn(menu)).href));
      menu.querySelector('.mbh-equipaje-clear').addEventListener('click', () => location.assign(makeUrl([]).href));
      item.append(fragment);
      sources.forEach(input => input.closest('.js-filter')?.classList.add('mbh-equipaje-source'));
    });
  };
  document.addEventListener('input', event => {
    if (event.target.closest('facet-filters-form')) preserveBike();
    if (event.target.matches('[data-mbh-sub]')) event.stopImmediatePropagation();
    // A different top-level category clears its luggage-only refinement.
    if (event.target.matches(categorySelector) && selected().length) event.stopImmediatePropagation();
  }, true);
  document.addEventListener('change', event => {
    const box = event.target;
    if (box.matches('[data-mbh-sub]')) {
      event.stopImmediatePropagation();
      const choice = choicesIn(box.closest('.mbh-equipaje-menu'));
      document.querySelectorAll(nativeSelector).forEach(input => { input.checked = choice.includes(input.value); });
      document.querySelectorAll('[data-mbh-sub]').forEach(input => { input.checked = choice.includes(input.dataset.mbhSub); });
      if (choice.length) document.querySelectorAll(categorySelector).forEach(input => { input.checked = input.value === 'Equipaje'; });
      return;
    }
    if (box.matches(categorySelector) && selected().length) {
      event.stopImmediatePropagation();
      const url = new URL(location.href);
      url.searchParams.delete(field);
      url.searchParams.delete('filter.p.product_type');
      url.searchParams.delete('page');
      box.form.querySelectorAll(`${categorySelector}:checked`).forEach(input => url.searchParams.append(input.name,input.value));
      location.assign(url.href);
    }
  }, true);
  document.addEventListener('click', event => {
    const removal = event.target.closest('facet-remove a');
    if (removal && bikeTags().length) {
      const url = new URL(removal.href);
      const currentTags = url.searchParams.getAll('filter.p.tag');
      bikeTags().forEach(tag => { if (!currentTags.includes(tag)) url.searchParams.append('filter.p.tag',tag); });
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(url.href);
      return;
    }
    const apply = event.target.closest('.mobile-facets__footer .button');
    const menu = apply?.closest('form')?.querySelector('.mbh-equipaje-menu');
    if (!menu) return;
    const choice = choicesIn(menu);
    if (JSON.stringify([...choice].sort()) !== JSON.stringify(selected().sort())) {
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(makeUrl(choice).href);
    }
  }, true);
  const start = () => {
    mount();
    const facets = document.getElementById('main-collection-filters');
    if (facets) new MutationObserver(mount).observe(facets,{childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();

  } catch(e) { console.error(e); }
})();
})();
